// extracted by mini-css-extract-plugin
export var createdDate = "_mm-1";
export var divider = "_mm-2";
export var headerDivider = "_mm-3";
export var messagesCard = "_mm-0";
export var messagesContainer = "_mm-7";
export var messagesContainerWrapper = "_mm-4";
export var pointerCapturingButtonBoxes = "_mm-a";
export var showLeftPanelButton = "_mm-9";
export var showMoreButton = "_mm-c";
export var showMoreButtonContainer = "_mm-b";
export var summaryTitle = "_mm-6";
export var systemMessageCardWrapper = "_mm-d";
export var topButtons = "_mm-8";
export var withPadding = "_mm-5";